export default __webpack_public_path__ + "static/media/trailerDynamic.71aeaed1.svg";